import CONSTANTS from '../CONSTANTS';

/**
 * @typedef {Object} PatientsPagination
 * @property {number} _page        - Current zero-based page index.
 * @property {number} _limit       - Page size used in the request.
 * @property {number} _total_pages - Total number of available pages.
 */

/**
 * @typedef {Object} PatientsState
 * @property {{ users: Object[], pagination: PatientsPagination }} patients - Paginated patient list.
 * @property {Object} editData - Patient object currently being edited.
 */

/** @type {PatientsState} */
const initialState = {
  patients: {
    users: [],
    pagination: {
      _page: 0,
      _limit: 10,
      _total_pages: 0,
    },
  },
  editData: {},
};

/**
 * Reducer for the patient management slice.
 *
 * @param {PatientsState} state
 * @param {Object} action
 * @returns {PatientsState}
 */
const usersPatientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTANTS.USERS_PATIENTS_SET_LIST:
      return { ...state, patients: action.patients };
    case CONSTANTS.USERS_PATIENT_SET_EDIT_DATA:
      return { ...state, editData: action.data };
    default:
      return state;
  }
};

export default usersPatientsReducer;